import React from 'react';
import Header from '../components/Header';
import ChannelsSection from '../components/ChannelsSection';
import Footer from '../components/Footer';
import SEO from '../components/SEO';

const CanalesPage = () => {
  const seoData = {
    title: 'Canales de Comunicación',
    description: 'Automatiza la atención al cliente en todos los canales: WhatsApp, Instagram, Facebook, Telegram, SMS, Email y más. Comunicación omnicanal inteligente.',
    keywords: 'canales comunicación, WhatsApp Business, Instagram automatización, Facebook Messenger, Telegram bot, SMS automatización, email automatización',
    canonical: '/canales',
    ogTitle: 'Canales de Comunicación Omnicanal - Runamatic',
    ogDescription: 'Conecta con tus clientes en WhatsApp, Instagram, Facebook, Telegram y más. Una plataforma, múltiples canales.',
    schema: {
      "@context": "https://schema.org",
      "@type": "Service",
      "name": "Canales de Comunicación Omnicanal",
      "description": "Automatización de atención al cliente en múltiples canales de comunicación",
      "provider": {
        "@type": "Organization",
        "name": "Runamatic",
        "url": "https://runamatic.io"
      },
      "serviceType": "Comunicación Omnicanal",
      "areaServed": "Worldwide"
    }
  };

  return (
    <>
      <SEO {...seoData} />
      <Header />
      <main>
        <ChannelsSection />
      </main>
      <Footer />
    </>
  );
};

export default CanalesPage; 